import { FC, ReactNode } from "react";
import AuthorizeHelper from "./AuthorizeHelper";
import Roles from "../../constants/roles";

interface IsAuthorizedRolesProps {
  roles: Roles[];
  children: ReactNode;
}

const IsAuthorizedRoles: FC<IsAuthorizedRolesProps> = ({ roles, children }) => {
  return <> {AuthorizeHelper.IsAuthorizedRole(roles) && children}</>;
};

export default IsAuthorizedRoles;
